<template>
    <div class="Panel Panel--statbox-dashboard">
        <div class="Panel__body">
            <div :class="classes">
                <div class="StatBox__title" v-html="title" @click.self="goTo()"></div>
                <div class="StatBox__primary-stat"><slot name="primaryStat"></slot></div>
                <div class="StatBox__secondary-stat"><slot name="secondaryStat"></slot></div>
                <dashboard-exporter :is-statbox="true" v-if="exportable"></dashboard-exporter>
            </div>
        </div>
        <div class="Panel__overlay" v-if="loading">
            <div class="Panel__overlay-text">
                <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isStatBox: true,
            }
        },

        props: {
            title: {
                required: true,
                type: String
            },

            clickable: {
                type: Boolean,
                default: false,
            },

            goToTarget: {
                type: String
            },

            targetUrl: {
                type: String
            },

            exportable: {
                type: Boolean,
                default: false,
            },

            loading: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            classes() {
                return {
                    'StatBox': true,
                    'StatBox--clickable': this.clickable,
                }
            }
        },

        methods: {
            goTo() {
                if (! this.clickable) return;

                let location = this.goToTarget;

                bus.$emit('show-loading-overlay');
                window.location = location ? this.targetUrl + '#' + location : this.targetUrl;
            },
        }
    }
</script>